import React, {Component} from 'react';
import ItemGrid from './ItemGrid';
import Sectiontitle from '../../component/Banner/Sectiontitle';

class portfolio extends Component {
    render() {
      var {pClass}= this.props;
      return(
        <section className={`portfolio_area ${pClass}`} id="portfolio">
            <div className="container">
                <Sectiontitle Title="Aliados con Pensu.io / S4B" 
                TitleP="Pensu.io y Sistemasdev aliados para brindar las mejores soluciones a los problemas de los clientes"/>
                <ItemGrid/>
            </div>
        </section>
      )
    }
  }

  export default portfolio;
